<template>
    <button class="back" @click="click">
        <IconBack class="icon-back" />
        <span> {{ $t("wv_global_01") }} </span>
    </button>
</template>

<script>
import IconBack from '@/assets/svg/icon-back.svg'

export default {
  name: 'BackButton',
  components: {
      IconBack
  },
  methods: {
      click(){
          this.$emit("click");
      }
  }
}

</script>

<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

.back{
    background-color: transparent;
    border: none;

    span {
        color: $color-white;
        font-size: 12px;
        letter-spacing: 0.25rem;
        text-transform: uppercase;
    }
}

</style>